import styled from "@emotion/styled";
import React from "react";
import ChatHeader from "./ChatHeader";
import ChatInput from "./ChatInput";
import Conversation from "./Conversation";
import useAppStore from "../appStore";
import { motion } from "framer-motion";

const variants = {
  open: { opacity: 1, y: 0, pointerEvents: "auto" },
  closed: { opacity: 0, y: 20, pointerEvents: "none" },
};
const ChatPopup = ({ sendMessage, messages }) => {
  const chatOpen = useAppStore((state) => state.chatOpen);
  return (
    <StyledChatPopup
      initial="closed"
      animate={chatOpen ? "open" : "closed"}
      variants={variants}
      transition={{ duration: 0.2 }}
    >
      <ChatHeader />
      <Conversation messages={messages} />
      <ChatInput sendMessage={sendMessage} />
    </StyledChatPopup>
  );
};

const StyledChatPopup = styled(motion.div)`
  position: relative;
  width: 400px;
  height: 500px;
  overflow: auto;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  /* @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
  } */
`;

export default ChatPopup;
